module.exports = __webpack_public_path__ + "img/chest_active.57a20add.png";